export const projects = [
  {
    slug: "rise-learning",
    name: "Rise Learning",
    industry: "Education & Training",
    year: "2026",
    client: "Rise Learning",
    url: "rise-learning.co.uk",
    liveUrl: "https://rise-learning.co.uk",
    secondaryUrl: "rise-learning.co.uk/courses",
    services: ["Website Design", "Development", "Mobile Optimisation"],
    tagline: "Mental health first aid for modern workplaces.",
    description:
      "A warm, professional website for an accredited mental health first aid training provider — designed to build trust and make booking a course effortless.",
    challenge:
      "Rise Learning delivers accredited Mental Health First Aid England training to workplaces across the UK. The website needed to feel warm and human without losing credibility — and to turn visiting HR and team leads into course bookings and team enquiries.",
    approach:
      "We designed around calm, editorial typography and a soft, approachable palette, with the trust signals — accreditation, experience and delivery track record — placed exactly where decisions get made. Booking an open course and enquiring for a team are never more than a tap away.",
    result:
      "A website that feels as considered as the training itself: clear course pathways, prominent open-course dates, and an enquiry flow that works beautifully on mobile — where most visitors first land.",
    highlights: [
      "Custom design system with a warm, editorial palette and serif typography",
      "Course pages with clear pathways for open courses and private in-house training",
      "Upcoming open-course dates with one-tap booking",
      "Accreditation and trust signals placed exactly where decisions get made",
      "A resources section built for ongoing learning and sharing",
      "Designed mobile-first — where most visitors first land",
    ],
    captions: {
      secondary: "The courses page — every training option laid out clearly, with formats and prices up front.",
      mobile: "Upcoming open courses on mobile — dates, locations and one-tap booking.",
    },
    images: {
      home: "/assets/rise-home.png",
      secondary: "/assets/rise-courses.png",
      mobile: "/assets/rise-mobile.png",
    },
  },
  {
    slug: "forge-fitness",
    name: "Forge Fitness",
    industry: "Fitness",
    year: "2026",
    client: "Forge Fitness Studio",
    url: "forgefitness.novo.studio",
    secondaryUrl: "forgefitness.novo.studio/classes",
    concept: true,
    services: ["Website Design", "Development", "Mobile Optimisation"],
    tagline: "Stronger Every Day.",
    description:
      "A bold, high-contrast digital home for a premium strength studio — designed to turn first-time visitors into members.",
    challenge:
      "Forge had the coaches, the space and the community — but a dated website that made a premium studio look like a budget gym. Class bookings lived on a third-party page, and mobile visitors dropped off before ever seeing the timetable.",
    approach:
      "We built a dark, high-contrast experience around dramatic black-and-white photography and condensed athletic typography. The class schedule was brought front and centre, and the join flow was reduced to a single, obvious action on every page.",
    result:
      "A site that finally feels like training at Forge: intense, polished and direct. The timetable is reachable in one tap on mobile, and the join flow carries visitors from first impression to membership enquiry without friction.",
    captions: {
      secondary: "The classes page — the full weekly timetable, front and centre.",
      mobile: "The homepage on mobile — bold, direct and built to convert.",
    },
    images: {
      home: "/assets/forge-home.png",
      secondary: "/assets/forge-classes.png",
      mobile: "/assets/forge-mobile.png",
    },
  },
  {
    slug: "voltex",
    name: "Voltex",
    industry: "Business",
    year: "2025",
    client: "Voltex Consulting",
    url: "voltex.novo.studio",
    secondaryUrl: "voltex.novo.studio/services",
    concept: true,
    services: ["Website Refresh", "Website Design", "Development"],
    tagline: "Smart Solutions for a Brighter Future.",
    description:
      "A complete website refresh that took a growing consultancy from a dated template to a confident, modern digital presence.",
    challenge:
      "Voltex was winning bigger clients, but its website told a different story — a generic template that undersold the firm's ambition and turned due-diligence checks by prospective clients into a liability rather than an asset.",
    approach:
      "We repositioned the site around restraint and confidence: a sophisticated dark palette, architectural photography, generous whitespace and copy trimmed to what actually matters. Services were restructured into four clear practice areas.",
    result:
      "A digital presence that matches the calibre of the work — calm, credible and considered — with an enquiries path that takes a prospective client from homepage to conversation in seconds.",
    captions: {
      secondary: "The services page — four clear practice areas, no jargon.",
      mobile: "The homepage on mobile — calm, credible and confident.",
    },
    images: {
      home: "/assets/voltex-home.png",
      secondary: "/assets/voltex-services.png",
      mobile: "/assets/voltex-mobile.png",
    },
  },
];
